import { render, staticRenderFns } from "./ProductDetailsView.vue?vue&type=template&id=1d3dbc3b&scoped=true&"
import script from "./ProductDetailsView.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsView.vue?vue&type=style&index=0&id=1d3dbc3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3dbc3b",
  null
  
)

export default component.exports